const downloadFile = (content:any, filename:string) => {
  const fileURL = window.URL.createObjectURL(new Blob([content]));
  const fileLink = document.createElement("a");
  fileLink.href = fileURL;
  fileLink.setAttribute("download", filename);
  document.body.appendChild(fileLink);
  fileLink.click();
  document.body.removeChild(fileLink);
}

export {
  downloadFile
}
